module.exports = __webpack_public_path__ + "img/cups.65e3db07.png";